"use client"

import * as React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"

import { Button } from "./elements/Button"

/**
 * The defaults reproduce the standalone control the auth and app shells use, so
 * existing call sites are unchanged. The props exist for the public header,
 * which drops this toggle inside its nav capsule - a 40px bordered square would
 * break the pill it sits in.
 */
export function ThemeSwitcher({ variant = "outline", size = "icon", className = "" }) {
  const { setTheme, theme } = useTheme()

  const changeTheme = () => {
    if(theme == 'dark') setTheme('light')
    else setTheme('dark')
  }

  return (
    // `relative` anchors the absolutely-positioned Moon to the button itself
    // rather than to whatever ancestor happens to be positioned.
    <Button variant={variant} size={size} onClick={changeTheme} tag="button" aria-label="Өнгөний горим солих" className={`relative ${className}`}>
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all motion-reduce:transition-none dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all motion-reduce:transition-none dark:rotate-0 dark:scale-100" />
    </Button>
  )
}
